import DataForm from "../Editor/DataForm";
import { EditCtrl } from "../Editor/index"

export default class OpravnenaOsobaEditCtrl extends EditCtrl {

  static $inject = ["item", "saveHandler",  "urovenOpravenenia", "getOdberneMiestoOteCheck"];

  constructor(item, saveHandler, urovenOpravenenia, getOdberneMiestoOteCheck){
    super(item, saveHandler, urovenOpravenenia);
    this.loadUrovenOpravenenia(urovenOpravenenia);
    this.load(item);
    this.getOdberneMiestoOteCheck = getOdberneMiestoOteCheck;
    this.resetValue = JSON.parse(JSON.stringify(item));
  }

  save(){
    this.saveHandler(this.item.id, this.item).then(item => this.load(this.item));
  }

  loadUrovenOpravenenia(urovenOpravenenia){
    this.urovenOpravenenia = urovenOpravenenia;
  }  

  doOdberneMiestoOteCheck() {
    this.item.odberneMiestoOte.opmEan = this.item.odberneMiestoOte.opmEan.replace(/\D/g,'');
    this.item.validEan = this.getOdberneMiestoOteCheck(this.item.odberneMiestoOte.opmEan).then(value => {
        if(value) {
          this.item.validEan = 'valid';
        }
        else {
          this.item.validEan = 'invalid';
        }

    });
    console.log(this.item.validEan);
  }

  reset() {
  	this.item = JSON.parse(JSON.stringify(this.resetValue));
  }


}



// WEBPACK FOOTER //
// ./src/OdberneMiesto/OpravnenaOsobaEditCtrl.js